import React, { Component } from 'react';
import styles from "../../TopicDots.module.css";

class Dot extends Component {
	audioRef = React.createRef();
	state = {
		playAnimation: false,
		playAudio: this.props.playAudio === this.audioRef.current
	}

	onEnded = () => {
		this.props.audioRefToPlay(null);
		this.setState({ playAnimation: false, playAudio: false })
		this.props.disableMenuButton(false)
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.playAudio !== this.props.playAudio) {
			this.setState({ playAudio: this.props.playAudio === this.audioRef.current }, () => {
				if (this.state.playAudio) {
					this.audioRef.current.play();
					this.setState({ playAnimation: true })
					this.props.disableMenuButton(true)
				} else {
					this.audioRef.current.pause();
					this.audioRef.current.currentTime = 0;
					this.setState({ playAnimation: false, playAudio: false })
				}
			})
		}
	}

	render() {
		return (
			<div className={styles.Dot} onClick={() => this.props.audioRefToPlay(this.audioRef.current)}>
				<audio onEnded={() => this.onEnded()} ref={this.audioRef} >
					<source src={this.props.audioSrc} type="audio/mpeg" />
				</audio>
				<div className={styles.DotMask}
				     style={{
					     animationName: this.state.playAnimation ? 'playMask' : 'none',
					     animationDuration: this.state.playAnimation ? `${this.audioRef.current.duration}s` : '0',
					     animationPlayState: this.state.playAnimation
				     }}
				/>
			</div>
		)
	}
}

export default Dot;